import * as Sentry from '@sentry/react'

export const APP_READY = 'app_ready'

let isMarked = false

/**
 * Records when the app first committed a render, in ms since navigation start (ISSUE-4266).
 *
 * FCP no longer says when the app is usable: since the boot loader in index.html it is the loader's
 * paint. This is the number to watch instead, as a `performance` mark and as a measurement on the
 * Sentry pageload transaction when one is sampled and still open. Runs once per page.
 */
export function markAppReady(): void {
  if (isMarked) return
  isMarked = true
  const sinceNavigationStart = performance.now()
  performance.mark?.(APP_READY)
  Sentry.getActiveTransaction()?.setMeasurement(APP_READY, sinceNavigationStart, 'millisecond')
}
